<h1 mat-dialog-title class="text-dark text-xl">
  {{ data.id ? 'Modifica Pratica Noleggio' : 'Nuova Pratica Noleggio' }}
</h1>
<div mat-dialog-content class="w-full">
  <app-rental-practices-form [data]="data"></app-rental-practices-form>
</div>
